<template>
    <div>
        <Dialog v-model:visible="visible" header="Select Users" :style="{ width: '50rem' }" @hide="emit('hide-dialog')" modal>
            <!-- Users Selection AutoComplete -->
            <UsersPicker @user-selected="usersSelected" />
            <!-- Show chips of active users selected -->
            <template v-if="activePanelUsers.length">
                <div class="my-3">
                    <h6>Selected Users:</h6>
                    <div class="flex flex-wrap gap-2 userchips-container overflow-y-auto">
                        <UserChips :users="activePanelUsers" @remove-user="removeSelectedUser" @remove-all-selected="removeAllSelected" />
                    </div>
                </div>
            </template>
            <template #footer>
                <Button label="Close" severity="warning" @click="emit('hide-dialog')" />
            </template>
        </Dialog>
    </div>
</template>

<script setup>
import UsersPicker from './UsersPicker.vue';
import UserChips from './UserChips.vue';

import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { userStore } from '../../../store/global-stores.js';

const emit = defineEmits(['users-selected', 'hide-dialog']);

const { activePanelUsers } = storeToRefs(userStore);
const visible = ref(true);

// Formats array of user ids of activePanelusers
const selectedUsersId = computed(() => {
    return activePanelUsers.value?.map((user) => user.id);
});

// Watches over any changes in the activePanelUsers and keeps emitting the updates
watch(
    () => selectedUsersId.value,
    () => emit('users-selected', selectedUsersId.value),
    {
        deep: true,
    }
);

// Everytime a user is selected on UsersPicker, it triggers this function
const usersSelected = (userDetails) => {
    // Make sure the userDetails is unique before pushing
    const userExists = activePanelUsers.value?.find((user) => user.id === userDetails.id);
    if (!userExists) {
        activePanelUsers.value?.push(userDetails);
    }
};

// If any selected user is removed from UserChips, then this function is triggered
const removeSelectedUser = (userId) => {
    // Check if user id exists
    const userIndex = activePanelUsers.value?.findIndex((user) => user.id === userId);
    // If it exists then remove it
    if (userIndex !== -1) {
        activePanelUsers.value?.slice(userIndex, 1);
    }
};

// This function is triggered when all users are removed at once from UserChips
const removeAllSelected = () => {
    activePanelUsers.value = [];
};
</script>

<style scoped>
.userchips-container {
    max-height: 10vh;
}
</style>
